'use client';
import React, { useEffect, useState } from "react";
import Image from 'next/image';
import backgroundImage from '../../public/images/try2.svg';

export default function Background() {
  const [opacity, setOpacity] = useState(0);

  const handleScroll = () => {
    let scrollValue = window.scrollY;
    let windowInnerHeight = window.innerHeight;
  const newOpacity = Math.min(scrollValue / windowInnerHeight, 1);
  setOpacity(newOpacity);
};

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const imgStyle = {
    opacity: 1 - opacity,
    transition: 'opacity 0.4s ease-in-out',
    borderRadius: '20px',
  };

  const overlayStyle = {
    backgroundImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0) 40%, rgba(0,0,0,0) 60%, rgba(0,0,0,1))',
    position: 'fixed' as 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };

  return (
      <div className="relative w-full h-screen max-h-[200vh] md:h-full self-auto bg-local">
        <Image
            className="w-full h-full object-cover md:object-contain md:object-center bg-fixed"
            style={imgStyle}
            src={backgroundImage}
            alt="Background image"
        />
        <div style={overlayStyle}></div>
      </div>
  );
}